var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5755 12.1504H29.6019V9.90803L16.0644 0.837891L2.39453 9.907V12.1504H15.5492V22.76H10.1798V23.7862H15.5492V30.5462H16.5755V23.7862H21.8166V22.76H16.5755V12.1504ZM16.5755 11.1242V3.06797L22.2795 11.1242H16.5755ZM28.5756 11.1242H23.5366L18.0902 3.42716L28.5756 10.452V11.1242ZM3.4208 10.4581L13.9913 3.44358L8.4454 11.1242H3.41669L3.4208 10.4581ZM9.71181 11.1242L15.5492 3.04128V11.1242H9.71181Z",
    fill: "#F6931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5796 18.3965V25.6696H22.7617V30.5464H23.788V29.6043H28.5796V30.5464H29.6059V19.4228H30.548V18.3965H28.5796ZM23.788 28.5781V26.6959H28.5796V28.5781H23.788Z",
    fill: "#F6931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42541 18.3965H1.45703V19.4227H2.39914V30.5464H3.42541V29.6043H8.21294V30.5464H9.2392V25.6696H3.42541V18.3965ZM8.21294 28.5781H3.42541V26.6959H8.21294V28.5781Z",
    fill: "#F6931E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.f88a29547de32f441ee1866fb0ece7fa.svg";
export { ForwardRef as ReactComponent };